import React from 'react';

export default () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36">
        <path
            d="M22.71 15.29a1 1 0 00-1.42 0L18 18.59l-3.29-3.3a1 1 0 00-1.42 1.42l3.3 3.29-3.3 3.29a1 1 0 000 1.42 1 1 0 001.42 0l3.29-3.3 3.29 3.3a1 1 0 001.42 0 1 1 0 000-1.42L19.41 20l3.3-3.29a1 1 0 000-1.42z"
            className="cls-1"
        />
        <path
            d="M34.55 27L21 3.7a3.48 3.48 0 00-6 0L1.45 27a3.34 3.34 0 003 5h27.11a3.34 3.34 0 002.99-5zm-1.73 2.28a1.39 1.39 0 01-1.26.71H4.44a1.39 1.39 0 01-1.26-.71 1.24 1.24 0 010-1.28L16.74 4.7a1.48 1.48 0 012.52 0L32.82 28a1.24 1.24 0 010 1.29z"
            className="cls-1"
        />
    </svg>
);
